import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../App/redux/store';
import { APIStatus } from '../../services/axiosEnums';
import getIdFromIdIri from '../../shared/parsers/getIdFromIdIri';
import {
  fetchCompanyStatsThunk,
  fetchCompanyThunk,
  updateCompanyThunk,
} from './services/companyThunks';

const initialState: CompanyState = {
  companyIdIri: null,
  companyId: null,
  company: { apiStatus: APIStatus.IDLE, result: null, error: undefined },
  companyStats: { apiStatus: APIStatus.IDLE, result: null, error: undefined },
};
const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCompanyIdIri: (state, action: PayloadAction<string | null>) => {
      state.companyIdIri = action.payload;
      state.companyId = action.payload ? getIdFromIdIri(action.payload) : null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyThunk.pending, (state) => {
        state.company.apiStatus = APIStatus.PENDING;
        state.company.error = undefined;
      })
      .addCase(
        fetchCompanyThunk.fulfilled,
        (state, action: PayloadAction<ICompany>) => {
          state.company.apiStatus = APIStatus.IDLE;
          state.company.result = action.payload;
          state.company.error = undefined;

          state.companyIdIri = action.payload.idIri;
          state.companyId = getIdFromIdIri(action.payload.idIri);
        },
      )
      .addCase(fetchCompanyThunk.rejected, (state, action) => {
        (state.company.apiStatus = APIStatus.REJECTED),
          (state.company.error = action.error);
      });
    builder
      .addCase(updateCompanyThunk.pending, (state) => {
        state.company.apiStatus = APIStatus.PENDING;
        state.company.error = undefined;
      })
      .addCase(
        updateCompanyThunk.fulfilled,
        (state, action: PayloadAction<ICompany>) => {
          state.company.apiStatus = APIStatus.IDLE;
          state.company.result = action.payload;
          state.company.error = undefined;

          state.companyIdIri = action.payload.idIri;
          state.companyId = getIdFromIdIri(action.payload.idIri);
        },
      )
      .addCase(updateCompanyThunk.rejected, (state, action) => {
        (state.company.apiStatus = APIStatus.REJECTED),
          (state.company.error = action.error);
      });
    builder
      .addCase(fetchCompanyStatsThunk.pending, (state) => {
        state.companyStats.apiStatus = APIStatus.PENDING;
        state.companyStats.error = undefined;
      })
      .addCase(
        fetchCompanyStatsThunk.fulfilled,
        (state, action: PayloadAction<CompanyStats>) => {
          state.companyStats.apiStatus = APIStatus.IDLE;
          state.companyStats.result = action.payload;
          state.companyStats.error = undefined;
        },
      )
      .addCase(fetchCompanyStatsThunk.rejected, (state, action) => {
        (state.company.apiStatus = APIStatus.REJECTED),
          (state.company.error = action.error);
      });
  },
});

export default companySlice.reducer;
export const companyActions = companySlice.actions;
export const getCompanyState = (state: RootState) => state.company;
